<h3>Recently Viewed</h3>
<div class="swiper">
  <swiper-container slides-per-view="auto" space-between="10" #swiper>
    @for (product of products; track $index) {
    <swiper-slide lazy="false">
      <app-product-list-item [data]="product"></app-product-list-item>
    </swiper-slide>
    }
  </swiper-container>
  <mat-icon
    class="prev"
    fontSet="material-symbols-outlined"
    inline
    (click)="swiper.swiper.slidePrev()"
    >chevron_left</mat-icon
  >
  <mat-icon
    class="next"
    fontSet="material-symbols-outlined"
    inline
    (click)="swiper.swiper.slideNext()"
    >chevron_right</mat-icon
  >
</div>
